import { useCallback, useEffect, useRef, useState } from "react";

export const useHorizontalOverflow = (selector = ".ag-body-horizontal-scroll-viewport") => {
  const containerRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  const checkOverflow = useCallback(() => {
    const viewport = containerRef.current?.querySelector(selector);
    if (viewport) {
      setHasOverflow(viewport.scrollWidth > viewport.clientWidth + 1);
    }
  }, [selector]);

  useEffect(() => {
    checkOverflow();
    const timers = [100, 300, 600, 1000].map((delay) => setTimeout(checkOverflow, delay));
    window.addEventListener("resize", checkOverflow);
    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [checkOverflow]);

  return { containerRef, hasOverflow, checkOverflow };
};
